'use client';

import type { FC } from 'react';
import React from 'react';
import style from '../style.module.scss';

import type Supercluster from 'supercluster';

import ActiveMarkerIcon from '../assets/active-marker-icon.png';
import AvailableMarkerIcon from '../assets/available-marker-icon.png';
import GeneralMarkerIcon from '../assets/general-marker-icon.png.png';
import NoAvailableMarkerIcon from '../assets/no-available-marker-icon.png';
import Image from "@/app/[lang]/components/shared/SmartImage";

interface MarkerProps {
    cluster: Supercluster.PointFeature<any>;
    openMarker: string | number | null;
    setOpenMarker: (id: string | number | null) => void;
    handleClusterZoom: () => void;
    lng: number;
    lat: number;
    handleMarkerSelect: () => void;
}

const Marker: FC<MarkerProps> = ({ cluster, openMarker, setOpenMarker, handleClusterZoom, handleMarkerSelect }) => {
    const { id, cluster: isCluster, point_count: pointCount } = cluster.properties;
    const tooltipOpen = id === openMarker;
    const markerStatus = cluster.properties?.data?.status;

    const markerIcon = tooltipOpen
        ? ActiveMarkerIcon
        : markerStatus === 'available'
            ? AvailableMarkerIcon
            : markerStatus === 'busy'
                ? NoAvailableMarkerIcon
                : GeneralMarkerIcon;

    const toggleTooltip = () => {
        if (tooltipOpen) {
            setOpenMarker(null);
        } else {
            handleMarkerSelect();
        }
    };

    if (isCluster) {
        return (
            <div className={style.cluster} onClick={handleClusterZoom}>
                <div>{pointCount}</div>
            </div>
        );
    }

    return (
        <div className={style.marker} onClick={toggleTooltip}>
            <Image
                src={markerIcon.src}
                alt="PPC Blue Romania"
                fill
                sizes="40px"
                loading="lazy"
                decoding="async"
            />
        </div>
    );
};

export default Marker;
